import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5c2e8216"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\lptni\\开发\\dev\\project\\unbox-server\\vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c2e8216')) {
      api.createRecord('5c2e8216', component.options)
    } else {
      api.reload('5c2e8216', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5c2e8216", function () {
      api.rerender('5c2e8216', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/demo/page3/index.vue"
export default component.exports